// External libs
import PropTypes from "prop-types";

/**
 * A simple widget component that displays two rows of text.
 *
 * @param {string} topRow - The text to display in the top row.
 * @param {string} bottomRow - The text to display in the bottom row.
 * @param {string} description - The description of the widget, displayed below the bottom row.
 *
 * @returns {JSX.Element} The rendered widget with top and bottom rows of text.
 *
 * @example
 * <WidgetTextBox topRow="Top Text" bottomRow="Bottom Text" />
 */
const WidgetTextBox = ({ topRow, bottomRow, description}) => {
  return (
    <div className="widget-text">
      <div className="number-chart-flex">
        <div className="number-chart-large-text number-chart-flex-left">
          {topRow}
        </div>
        <div className="number-chart-title">{bottomRow}</div>
        <div className="number-chart-title">{description}</div>
      </div>
    </div>
  );
};

WidgetTextBox.propTypes = {
  topRow: PropTypes.string.isRequired,
  bottomRow: PropTypes.string.isRequired,
};

export default WidgetTextBox;
